import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Sparkles, ShieldCheck, Smile, TrendingUp, ArrowRight } from "lucide-react";

const values = [
  { icon: <Sparkles size={24} />, title: "Confidence first", desc: "Every child progresses at their own pace — no pressure, no comparisons.", accent: "#4FA3C6" },
  { icon: <ShieldCheck size={24} />, title: "Safety always", desc: "Qualified teachers, clear procedures and a calm, controlled pool.", accent: "#1F7A8C" },
  { icon: <Smile size={24} />, title: "Joyful learning", desc: "Playful, engaging lessons — because happy children learn faster.", accent: "#F59E0B" },
  { icon: <TrendingUp size={24} />, title: "A skill for life", desc: "Structured stages with clear milestones and progress you can see.", accent: "#6ED3C3" },
];

export default function ValuesStrip() {
  return (
    <section id="values" className="py-24 md:py-28 bg-white" data-testid="values-strip">
      <div className="container mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-sm text-[#0EA5E9] tracking-[0.2em] uppercase font-bold">Why Happy Tiddlers</span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] leading-tight">
            Built on the things that matter most
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {values.map((v, i) => (
            <motion.div
              key={v.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-[#F8FAFC] rounded-[2rem] p-8 border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-500"
              data-testid={`value-card-${i}`}
            >
              <span className="grid place-items-center w-14 h-14 rounded-2xl mb-6 text-white" style={{ backgroundColor: v.accent }}>
                {v.icon}
              </span>
              <h3 className="font-heading text-xl font-semibold text-[#0F172A]">{v.title}</h3>
              <p className="mt-3 text-[#334155] leading-relaxed">{v.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-12">
          <Link to="/about" className="inline-flex items-center gap-2 font-bold text-[#0EA5E9] hover:gap-3 transition-all" data-testid="values-about-link">
            More about our approach <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
